// components/Loader.js

import React from "react";
import { Spin } from "antd";

const Loader = () => {
  return (
    <div
  style={{
    height: "100vh", // full screen height
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  }}
>
  <Spin size="large" />
</div>

  );
};

export default Loader;
